
document.addEventListener("DOMContentLoaded", function(){

    jQuery('.div_select2').click(function (e){
        e.preventDefault();
        let myModal = new Modal(document.getElementById('variationsModal'));
        myModal.show();
    });

    jQuery( ".single_variation_wrap" ).on( "show_variation", function ( event, variation ) {
        console.log( variation );
        jQuery('.popup-preview img').attr('src',variation.image.thumb_src);
        jQuery('.price-preview').html(variation.price_html);
    } );

    jQuery( '.variations_form' ).on( 'woocommerce_variation_select_change', function() {
        jQuery('table.variations select').each(function (index,select){
            let id = jQuery(select).attr('id');
            let val = jQuery(select).val();
            jQuery('#'+id+'_select2').val(val);
        })
    });

    jQuery( "#account-toggle" ).click(function(e) {
        e.preventDefault();
        jQuery(this).parents().find('ul.account-links.dropdown-menu').toggle();
    });

    onResizeOrLoad();
    addEventListener("resize", onResizeOrLoad);

    window.setTimeout(function (){
        window.dispatchEvent(new Event('resize'));
    },500);
    window.setTimeout(function (){
        window.dispatchEvent(new Event('resize'));
    },5000);
});

function onResizeOrLoad(){
    let width = window.innerWidth;
    if(width > 767)
        jQuery('.woocommerce-tabs.wc-tabs-wrapper').insertAfter(jQuery('.type-product > .row > .col-12 .images'));
    else
        jQuery('.woocommerce-tabs.wc-tabs-wrapper').insertBefore(jQuery('.insert-description-mobile'));
}